import { useEffect } from 'react';

import ReactModal from 'react-modal';

export const Auth3DSecureModal = ({
  auth3DSRedirectUrl,
  onAuth3DSecureComplete,
}: {
  auth3DSRedirectUrl: string;
  onAuth3DSecureComplete: () => void;
}) => {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handle3DSCompleteEvent = (event: any) => {
      if (event.data === '3DS-authentication-complete') {
        onAuth3DSecureComplete();
      }
    };

    window.addEventListener('message', handle3DSCompleteEvent);
    return () => window.removeEventListener('message', handle3DSCompleteEvent);
  }, [onAuth3DSecureComplete]);

  return (
    <ReactModal
      className="absolute left-1/2 top-1/2 max-w-full -translate-x-1/2 -translate-y-1/2 overflow-auto rounded-s border border-secondary-80 bg-white shadow-black-m outline-none"
      overlayClassName="fixed z-[15] inset-0 bg-[rgb(238_243_247/75%)]"
      isOpen={true}
      shouldCloseOnOverlayClick={false}
      ariaHideApp={false}
    >
      <iframe
        title="3D Secure"
        src={auth3DSRedirectUrl}
        width={600}
        height={500}
        className="border-none"
      />
    </ReactModal>
  );
};
